import {
  useAnnouncement,
  useCreateAnnouncement,
  useDeleteAnnouncement,
  useUpdateAnnouncement,
} from "./announcement";
import {
  useApprovers,
  useCreateApprovers,
  useDeleteApprovers,
  useUpdateApprovers,
} from "./approvers";
import {
  useAsset,
  useCreateAsset,
  useCreateAssetBatch,
  useDeleteAsset,
  useUpdateAsset,
} from "./assets";
import {
  useExtendSession,
  useForgotPassword,
  useLogin,
  useResetPassword,
  useThirdPartyLogin,
  useVerifyLoginOtp,
} from "./auth";
import {
  useAllRounds,
  useAvailableBid,
  useBid,
  useCreateBid,
  useDeleteBid,
  useUpdateBid,
} from "./bid";
import {
  useCaveat,
  useCreateCaveat,
  useDeleteCaveat,
  useUpdateCaveat,
} from "./caveat";
import {
  useAddWitness,
  useConfirmPayment,
  useWitnessApprove,
  useGenerateReceipt,
  useClaimAsset,
  usePendingWitness,
  usePaymentValidation,
  usePaid,
  useLogs,
  useCompleted,
  useMetrics,
} from "./claim";
import {
  useExpressInterest,
  useGetEOIByRound,
  useMyEOI,
  useWithdrawInterest,
} from "./eoi";
import {
  useCreateMaintenance,
  useDeleteMaintenance,
  useMaintenance,
  useUpdateMaintenance,
} from "./maintenance";
import {
  useGetBidByRound,
  useGetLeaderBoardByRound,
  useMyBids,
  useMyParticipation,
  usePlaceBid,
} from "./placeBid";
import { useCreateSLA, useDeleteSLA, useSLA, useUpdateSLA } from "./sla";
import {
  useCreateTemplates,
  useDeleteTemplates,
  useTemplates,
  useUpdateTemplates,
} from "./templates";
import { usePendingTP, useTPActions, useTPEvidence } from "./tp";
import {
  useCreateThirdParty,
  useDeleteUser,
  useUpdateUser,
  useUsers,
  useUsersOnline,
} from "./users";

export const hooks = {
  useLogin,
  useThirdPartyLogin,
  useExtendSession,
  useForgotPassword,
  useResetPassword,
  useVerifyLoginOtp,
  useBid,
  useCreateBid,
  useUpdateBid,
  useDeleteBid,
  useAsset,
  useCreateAsset,
  useUpdateAsset,
  useDeleteAsset,
  useAvailableBid,
  useMyEOI,
  useGetEOIByRound,
  useExpressInterest,
  useWithdrawInterest,
  useMyBids,
  useGetBidByRound,
  useGetLeaderBoardByRound,
  usePlaceBid,
  useSLA,
  useCreateSLA,
  useDeleteSLA,
  useUpdateSLA,
  useMyParticipation,
  useAnnouncement,
  useCreateAnnouncement,
  useUpdateAnnouncement,
  useDeleteAnnouncement,
  useCaveat,
  useCreateCaveat,
  useUpdateCaveat,
  useDeleteCaveat,
  useTemplates,
  useCreateTemplates,
  useDeleteTemplates,
  useUpdateTemplates,
  useMaintenance,
  useUpdateMaintenance,
  useCreateMaintenance,
  useDeleteMaintenance,
  useUsers,
  useUsersOnline,
  useCreateThirdParty,
  useUpdateUser,
  useDeleteUser,
  useAllRounds,
  useClaimAsset,
  useAddWitness,
  useConfirmPayment,
  useWitnessApprove,
  useGenerateReceipt,
  usePendingWitness,
  usePaymentValidation,
  usePaid,
  useLogs,
  useCompleted,
  useMetrics,
  useCreateAssetBatch,
  useApprovers,
  useCreateApprovers,
  useUpdateApprovers,
  useDeleteApprovers,
  useTPEvidence,
  usePendingTP,
  useTPActions,
};
